import PropTypes from 'prop-types';
import React from 'react';

export default function Arrow({ expanded }) {
  return (
    <div className={`arrow${expanded ? ' expanded' : ''}`}>
      <svg className="arrowIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 -0.5 9 5.55">
        <polyline points=".5 .5 4.55 4.55 8.5 .6" />
      </svg>
    </div>
  );
}

Arrow.propTypes = {
  expanded: PropTypes.bool.isRequired,
};
